export default __webpack_public_path__ + "static/media/red.f8ff1611.svg";